import { memo } from 'react';
import cn from 'classnames';
import NotesIcon from '@assets/images/NotesIcon';
import styles from './CartItems.module.scss';

const ModifierList = ({ modifiersObj, n, nest, serverAppTheme, displayPrice }) => (
  <ul className={cn('pl-0 m-0 ')} style={{ listStyle: 'none' }}>
    {modifiersObj.map((modifier, index) => (
      <li
        style={{ color: 'black'}}
        key={modifier.modifierId + modifier.modifierGroupId}
      >
        <div
          className={cn(
            !(nest && index === 1) && 'mt-1',
            nest && index === 1 && styles.nestedModPad
          )}
          style={{ fontSize: nest ? '12px' : '13px' }}
        >
          <span className="fs_18" style={{ color: serverAppTheme?.modifier_arrowDown }}>- </span>
          {modifier.quantity > 1 && (
            <span className="m-0 va-tt">
              {modifier.quantity}<span>x</span>{' '}
            </span>
          )}
          {modifier.modifierName}
          {displayPrice && Number(modifier.price) > 0 && (
            <span className="pl-1 text-muted" style={{ fontWeight: 500 }}>
              {`($${Number(modifier.price).toFixed(2)})`}
            </span>
          )}
        </div>
        {(modifier.note || modifier.comment) && (
          <div className="col-12 px-0 row mx-0">
            <span className="col-1 px-0 fs_12">
              <NotesIcon />
            </span>
            <span
              className={cn('pl-2 col-11 pr-0 fs_12', styles.modifierNoteAndComment)}
              style={{ '--note-color': serverAppTheme?.primary_text }}
            >
              {modifier.note || modifier.comment}
            </span>
          </div>
        )}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="ml-3 mt-1 fs_10">
            <ModifierList
              modifiersObj={modifier.modifiers}
              n={n}
              nest={true}
              serverAppTheme={serverAppTheme}
              displayPrice={displayPrice}
            />
          </div>
        )}
      </li>
    ))}
  </ul>
);

const MemoizedModifierList = memo(ModifierList);

export default MemoizedModifierList;
